"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = usePassiveRedux;

var _react = require("react");

var _reactRedux = require("react-redux");

function usePassiveRedux(selector) {
  var _useContext = (0, _react.useContext)(_reactRedux.ReactReduxContext),
      store = _useContext.store;

  if (!store) {
    throw new Error('[usePassiveRedux] Could not find store in context. in order to `usePassiveRedux` you must add `Provider` from react-redux');
  }

  return selector(store.getState());
}